import React, { FC } from 'react'

import MenuItem from '@pixel/core/MenuItem'
import { LocalizedText } from '../contexts/Localization/LocalizationTypes'
import { useLocalizedText } from '../contexts/Localization/localizationHooks'

export const renderLocalizedMenuItems = ({ text, value }: { text: LocalizedText, value: any }) => {
    const textValue = useLocalizedText(text)

    return (
        <MenuItem key={value} value={value}>{textValue}</MenuItem>
    )
}

